import React from 'react';
import PropTypes from 'prop-types';
import { injectStripe } from 'react-stripe-elements';
import { priceDecimalFormatter } from 'formatter/preset.formatter';
import CardSection from './CardSection';

function CheckoutForm({
  orderHandler,
  loadingHandler,
  elements,
  stripe,
  totalPrice,
  setSaveCard,
  disabled,
}) {
  const handleSubmit = async ev => {
    ev.preventDefault();
    if (disabled) return;
    loadingHandler();
    try {
      const result = await stripe.createPaymentMethod({
        type: 'card',
        card: elements.getElement('card'),
      });
      orderHandler(result.paymentMethod.id);
    } catch (err) {
      orderHandler(err);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {/* Render either the Bank or Card section based on isEft flag */}
      <CardSection />
      <label
        htmlFor="saveCard"
        className="flex items-start gap-2.5 mt-4 mb-1 cursor-pointer select-none"
      >
        <input
          type="checkbox"
          id="saveCard"
          onChange={() => setSaveCard(prev => !prev)}
          className="mt-0.5 w-4 h-4 rounded border-gray-300 text-[#E53935] focus:ring-[#E53935]"
        />
        <span className="text-xs text-gray-500 leading-relaxed">
          Save this card for later. This will speed up your checkout process
          next time.
        </span>
      </label>
      <button
        className="w-full mt-4 py-3.5 rounded-xl bg-[#E53935] hover:bg-[#d32f2f] disabled:opacity-40 disabled:pointer-events-none text-white font-heading font-bold text-base shadow-md shadow-red-500/20 active:scale-98 transition-all"
        type="submit"
        disabled={disabled}
      >
        Pay ${priceDecimalFormatter(totalPrice)}
      </button>
    </form>
  );
}

CheckoutForm.propTypes = {
  orderHandler: PropTypes.func,
  loadingHandler: PropTypes.func,
  setSaveCard: PropTypes.func,
  disabled: PropTypes.bool,
  stripe: PropTypes.shape({
    createPaymentMethod: PropTypes.func.isRequired,
  }).isRequired,
  elements: PropTypes.shape({
    getElement: PropTypes.func.isRequired,
  }).isRequired,
  totalPrice: PropTypes.number.isRequired,
};

CheckoutForm.defaultProps = {
  orderHandler: () => {},
  loadingHandler: () => {},
  setSaveCard: () => {},
  disabled: false,
};

export default injectStripe(CheckoutForm);
